import React, { Component } from 'react'
import CurrencyFormat from 'react-currency-format'
import { connect } from 'react-redux'
import { CalculFraisDeNotaire, UpdateIntField } from '../../engine/Rules'
import { InfoBulle } from '../ImportAll'
import './Bloc.css'

class BlocFraisDeNotaire extends Component {
    render() {
        /////////////////////////////////
        // définition du style du bloc //
        /////////////////////////////////
        let className = 'Bloc fade-in bloc-full selected'
        const style = {}

        //////////////////////////////////
        // définition de l'état du bloc //
        //////////////////////////////////

        let infobulle = (
            <div className="infoBulleContainer">
                <InfoBulle text="Si vous connaissez les frais de notaire, indiquez-les. Sinon, ils seront calculés automatiquement." />
            </div>
        )

        var fraisDeNotairePreCalc = null
        var fraisOrigin = ''

        if (this.props.targetDataValue!=undefined) {
            fraisDeNotairePreCalc = this.props.targetDataValue
            fraisOrigin = '( vos informations )'
        } else {
             CalculFraisDeNotaire(
                        this.props.prixAchat,
                        this.props.prixTerrain,
                        this.props.projetType,
                        true
                    )
            fraisDeNotairePreCalc = this.props.frais_notaire_calc
            fraisOrigin = '( estimation )'
        }

        var premadeContent = (
            <div className="frais-notaire">
                <div className="infoBulleContainer"></div>
                <div className="text1 size14 regular-font">
                    Frais de notaire {fraisOrigin} :{' '}
                </div>
                <div className="text2 size18 bold-font">
                    {fraisDeNotairePreCalc} €{' '}
                </div>
                <div className="text3 size14 regular-font">
                    Entrez votre propre prévision
                </div>
                <div className="text4 size11 medium-font">
                    Si cette estimation est différente <br />
                    de celle de votre notaire
                </div>
                <CurrencyFormat
                    value={this.props.targetDataValue}
                    placeholder="Ex : 15 200 €"
                    className="field bold-font"
                    thousandSeparator={' '}
                    type="tel"
                    decimalSeparator={','}
                    suffix=" €"
                    onValueChange={(value) =>
                        UpdateIntField(this.props.linked_data_id, value)
                    }
                />
            </div>
        )
        style.height = '244px'

        return (
            <div>
                <div className={className} style={style}>
                    {infobulle}
                    {premadeContent}
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        prixAchat: state.answer['prj_montant_achat'],
        prixTerrain: state.answer['prj_montant_terrain'],
        prixConstruction: state.answer['prj_montant_construction'],
        projetType: state.answer['prj_type'],
        targetDataValue: state.answer[ownProps.linked_data_id],
        frais_notaire_calc: state.answer['frais_de_notaire']
    }
}

export default connect(mapStateToProps)(BlocFraisDeNotaire)
